import React from "react";
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import {useValue} from "@morningtrain/react-resources";

function Image(props) {
    const {name, defaultValue} = props;

    let value = useValue(name, defaultValue);

    let image = <img width={props.width}
                     height={props.height}
                     className={props.className}
                     alt={props.alt}
                     title={props.title}
                     src={value}/>;

    if (props.link === true) {
        return (
            <a href={value} target={props.target} className={props.className}>
                {image}
            </a>
        );
    }

    return image;
}

Image.defaultProps = {
    defaultValue: null,
    className: '',
    target: '_blank',
    link: false,
    width: null,
    height: null,
    alt: null,
    title: null,
}

Image.propTypes = {
    name: PropTypes.string.isRequired,
    defaultValue: PropTypes.any,
    className: PropTypes.string,
    target: PropTypes.oneOf(['_blank', '_self', '_parent', '_top']),
    link: PropTypes.bool,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string,
    title: PropTypes.string,
}

export default observer(Image);

